import { useAnalytics } from "~/components/Analytics";
import { LandingPageBuildHtml } from "~/components/LandingPageV2/LandingPageBuildHtml";
import { LandingPageCTAs } from "~/components/LandingPageV2/components/LandingPageCTAs";
import { WysiwygBlock as WysiwygBlockType } from "~/components/LandingPageV2/schemas";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";

export type WysiwygBlockProps = Pick<
  WysiwygBlockType,
  "wysiwyg" | "includeCtas" | "ctaAlignment" | "primaryCta" | "secondaryCta"
> & { blockIndex: number };

export const WysiwygBlock: React.FC<WysiwygBlockProps> = ({
  wysiwyg,
  ctaAlignment,
  includeCtas,
  primaryCta,
  secondaryCta,
}) => {
  const { analyticsEnhancedTrack } = useAnalytics();
  const primaryButtonClick = () =>
    analyticsEnhancedTrack("Clicked Primary CTA", {
      context: "wysiwyg",
      linkText: getValueOrDefault(primaryCta?.title, null),
      linkUrl: getValueOrDefault(primaryCta?.url, null),
    });

  const secondaryButtonClick = () =>
    analyticsEnhancedTrack("Clicked Secondary CTA", {
      context: "wysiwyg",
      linkText: getValueOrDefault(secondaryCta?.title, null),
      linkUrl: getValueOrDefault(secondaryCta?.url, null),
    });

  return (
    // text-align: center looks weird in mobile, so apply
    // `text-align: left !important` on mobile breakpoints
    <div className="[&>*]:sm-max:!text-start">
      <LandingPageBuildHtml html={wysiwyg} />
      <LandingPageCTAs
        includeCtas={includeCtas}
        ctaAlignment={ctaAlignment}
        onPrimaryClick={primaryButtonClick}
        onSecondaryClick={secondaryButtonClick}
        primaryCta={primaryCta}
        secondaryCta={secondaryCta}
      />
    </div>
  );
};
